/* tslint:disable */
/* eslint-disable */
/**
 * Marsinet API
 * Esta API es utilizada tanto por Marsinet como por MarsiConnect. Proporciona todos los endpoints actualizados y documentación detallada, incluyendo ejemplos de datos y mocks de prueba para verificar el comportamiento de cada llamada.
 *
 * OpenAPI spec version: 5.0.1
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

/**
 *
 *
 * @export
 * @interface SurveyRecipientDto
 */
export interface SurveyRecipientDto {
  /**
   * Full name of the subscribed user.
   *
   * @type {string}
   * @memberof SurveyRecipientDto
   * @example John Doe
   */
  user_name: string;

  /**
   * Full name of the subscribed users organization.
   *
   * @type {string}
   * @memberof SurveyRecipientDto
   * @example Clínico Marsinet
   */
  org_name: string;

  /**
   * Current response state of the recipient.
   *
   * @type {string}
   * @memberof SurveyRecipientDto
   * @example pending
   */
  state: SurveyRecipientDtoStateEnum;

  /**
   * Days left to respond. Null if no time limit is set.
   *
   * @type {number}
   * @memberof SurveyRecipientDto
   * @example 3
   */
  days_left?: number;
}

/**
 * @export
 * @enum {string}
 */
export enum SurveyRecipientDtoStateEnum {
  Pending = 'pending',
  Answered = 'answered',
  Overdue = 'overdue',
}
